const data = {
	"width": 2048,
	"height": 2048,
	"body": "<path fill=\"currentColor\" d=\"M1408 512h512v512h-128V731l-576 575l-256-256l-704 705v37h1664v128H128V128h128v1445l704-703l256 256l485-486h-293V512z\"/>"
};
exports.__esModule = true;
exports.default = data;
